import { CHAT_STAT_COLUMNS } from "./Columns/Chat";
import BulkCampaignStat from "./BulkCampaignStat";

export default BulkChatCampaignStats;

// Replaced by shared CHAT_STAT_COLUMNS so Call/Chat columns stay in sync.
// function getBulkChatCampaignStats(chatCampaignDetails: any) {
//   const bulkChatCampaignStats = [
//     { label: "Responded Users", data: chatCampaignDetails?.usersResponded },
//     {
//       label: "Messages Attempted",
//       data: chatCampaignDetails?.messagesAttempted,
//     },
//     { label: "Messages Sent", data: chatCampaignDetails?.messagesSent },
//     { label: "Messages Failed", data: chatCampaignDetails?.messagesFailed },
//     { label: "Messages Blocked", data: chatCampaignDetails?.messagesBlocked },
//   ];
//
//   return bulkChatCampaignStats;
// }

interface BulkChatCampaignStatsProps {
  chatCampaignDetails: any;
  totalContacts: number;
  // Kept for future extensibility (Frontend uses this to switch to EMAIL_STAT_COLUMNS); Catalyst has
  // no Email channel, so CHAT_STAT_COLUMNS is always used here regardless of this prop's value.
  campaignType?: string;
}

function BulkChatCampaignStats(props: BulkChatCampaignStatsProps) {
  const { chatCampaignDetails, totalContacts } = props;
  const statInput = { totalContacts, chatCampaignDetails };

  return (
    <>
      {CHAT_STAT_COLUMNS.map((col) => (
        <BulkCampaignStat
          key={col.headerLabel}
          data={col.getValue(statInput)}
          label={col.rowLabel}
        />
      ))}
    </>
  );
}
